import { Action } from 'redux';

import { EnterPublishedConnectionTableSubspace } from '~src/app/actions/AppActionTypes';
import { isActionFactory } from '~src/app/actions/isActionFactory';
import { PublishedConnectionTableSubspaceName } from '~src/app/state/SpaceInfo';
import { IPublishedConnectionTableDetailInfo } from '~src/ts/models/IPublishedConnectionTableInfo';

export interface EnterPublishedConnectionTableSubspaceReduxAction extends Action {
  readonly publishedConnectionTableDetailInfo: IPublishedConnectionTableDetailInfo;
  readonly subspaceName: PublishedConnectionTableSubspaceName;
  readonly requestContent: boolean;
}

export function enterPublishedConnectionTableSubspace(
  publishedConnectionTableDetailInfo: IPublishedConnectionTableDetailInfo,
  subspaceName: PublishedConnectionTableSubspaceName,
  requestContent: boolean,
): EnterPublishedConnectionTableSubspaceReduxAction {
  return {
    type: EnterPublishedConnectionTableSubspace,
    publishedConnectionTableDetailInfo,
    subspaceName,
    requestContent
  };
}

export const isEnterPublishedConnectionTableSubspaceAction = isActionFactory<EnterPublishedConnectionTableSubspaceReduxAction>(EnterPublishedConnectionTableSubspace);
